import type { ComponentProps, FC } from 'react';

import Checkbox from '@trend-dev/trendtech-ui/components/UI/Checkbox';

import { agreementContent } from '../const';
import styles from './styles.module.scss';

interface Props {
    onChange: ComponentProps<typeof Checkbox>['onChange'];
}

const Agreement: FC<Props> = ({ onChange }) => {
    return (
        <div className={styles.wrapper}>
            <Checkbox size='xs' onChange={onChange} className={styles.checkbox} />
            {agreementContent}
        </div>
    );
};

export default Agreement;
